import { CommonModule, NgClass } from '@angular/common';
import { Component, signal } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserOnlineState } from '@sendbird/chat';
import { CSSelectComponent } from 'src/app/shared/components/cs-select/cs-select.component';
import { MatConnectedDialog, MatConnectedDialogMobileAnimation } from 'src/app/shared/service/connected-dialog';
import { SendbirdChatService } from '../../sendbird-chat.service';
import { ChatRuleComponent } from '../chat-rule/chat-rule.component';

@UntilDestroy()
@Component({
  standalone: true,
  imports: [CommonModule, NgClass, CSSelectComponent],
  selector: 'app-chat-header',
  templateUrl: './chat-header.component.html',
  styleUrls: ['./chat-header.component.scss'],
})
export class ChatHeaderComponent {
  totalMemberCount = signal(0);
  channelList = signal<{ value: string; label: string; disable: boolean }[]>([]); // 使用 signal 來追蹤頻道列表
  currentChannelUrl = '';
  readonly selectedChannel = this.sendbirdChatService.selectedChannel;
  readonly isLoading = this.sendbirdChatService.isLoading;

  constructor(
    private matConnectedDialog: MatConnectedDialog,
    public sendbirdChatService: SendbirdChatService,
  ) {}

  private calcMemberOnlineCount() {
    const count =
      this.selectedChannel()?.members?.filter(member => member.connectionStatus === UserOnlineState.ONLINE).length || 0;
    this.totalMemberCount.set(count);
  }

  ngOnInit() {
    // subscribe to channel list updates
    this.sendbirdChatService.channelList$.pipe(untilDestroyed(this)).subscribe(async channels => {
      this.channelList.set(channels);
      if (!this.currentChannelUrl && channels.length > 0) {
        await this.selectChannel(channels[0].value);
      } else {
        this.currentChannelUrl = '';
      }
    });
    this.sendbirdChatService.userStatus$.pipe(untilDestroyed(this)).subscribe(async status => {
      this.calcMemberOnlineCount();
    });
  }

  async selectChannel(url: string) {
    await this.sendbirdChatService.joinChannel(url);
    this.currentChannelUrl = url;
    this.calcMemberOnlineCount();

    // this.shouldScroll = true; // 確保在加入頻道後滾動到底部
  }

  handleOpenChatRule() {
    this.matConnectedDialog.open(ChatRuleComponent, {
      mobileAnimation: MatConnectedDialogMobileAnimation.SLIDE_UP,
      mobileFixedBottom: true,
    });
  }
}
